// @flow

import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const {Types, Creators} = createActions({
    createLoginRequest: ['email', 'password'],
    createLoginSuccess: ['loginToken'],
    createLoginError: ['error'],
    createRegisterRequest: ['name', 'email', 'password'],
    createRegisterSuccess: null,
    createRegisterError: ['error'],
    createForgotRequest: ['email'],
    createForgotSuccess: ['response'],
    createForgotError: ['error'],
    createLogoutRequest: null,
    createLogoutSuccess: null,
    createLogoutError: ['error'],

    resetPasswordRequest: ['password', 'forgotToken'],
    resetPasswordSuccess: null,
    resetPasswordError: ['error'],
})

export const LoginTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
    error: undefined,
    fetching: false,
    loginToken: undefined,
    forgotPasswordMessage: undefined,
    role: undefined
})

/* ------------- Reducers ------------- */

export const processCreateLoginRequest = (state: Object) => state.merge({
    fetching: true,
    error: undefined,
    loginToken: undefined,
    forgotPasswordMessage: undefined,
})

export const processCreateLoginSuccess = (state: Object, {loginToken}: Object) => {
    const {token, role} = loginToken
    return state.merge({
        fetching: false,
        forgotPasswordMessage: undefined,
        error: undefined,
        loginToken: token,
        role
    })
}

export const processCreateLoginError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    forgotPasswordMessage: undefined,
    error,
    loginToken: undefined
})

export const processCreateRegisterRequest = (state: Object) => state.merge({
    fetching: true,
    forgotPasswordMessage: undefined,
    error: undefined
})

export const processCreateRegisterSuccess = (state: Object) => state.merge({
    fetching: false,
    error: undefined
})

export const processCreateRegisterError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    forgotPasswordMessage: undefined,
    error
})

export const processCreateForgotRequest = (state: Object) => state.merge({
    fetching: true,
    error: undefined
})

export const processCreateForgotSuccess = (state: Object, {response}: Object) => state.merge({
    fetching: false,
    forgotPasswordMessage: response.message,
    error: undefined
})


export const processCreateForgotError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    forgotPasswordMessage: undefined,
    error
})

export const processCreateLogoutRequest = (state: Object) => state.merge({
    fetching: true,
    error: undefined,
    forgotPasswordMessage: undefined,
})

export const processCreateLogoutSuccess = (state: Object) => {
    localStorage.removeItem('login_token')
    localStorage.removeItem('role')
    localStorage.removeItem('campaign')
    localStorage.removeItem('id')
    return INITIAL_STATE
}

export const processCreateLogoutError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    forgotPasswordMessage: undefined,
    error
})


export const processResetPasswordRequest = (state: Object) => state.merge({
    fetching: true,
    forgotPasswordMessage: undefined,
    error: undefined
})

export const processResetPasswordSuccess = (state: Object) => {
    return state.merge({
        fetching: false,
        forgotPasswordMessage: undefined,
        error: undefined
    })
}

export const processResetPasswordError = (state: Object, {error}: Object) => state.merge({
    fetching: false,
    forgotPasswordMessage: undefined,
    error
})

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
    [Types.CREATE_LOGIN_REQUEST]: processCreateLoginRequest,
    [Types.CREATE_LOGIN_SUCCESS]: processCreateLoginSuccess,
    [Types.CREATE_LOGIN_ERROR]: processCreateLoginError,
    [Types.CREATE_REGISTER_REQUEST]: processCreateRegisterRequest,
    [Types.CREATE_REGISTER_SUCCESS]: processCreateRegisterSuccess,
    [Types.CREATE_REGISTER_ERROR]: processCreateRegisterError,
    [Types.CREATE_FORGOT_REQUEST]: processCreateForgotRequest,
    [Types.CREATE_FORGOT_SUCCESS]: processCreateForgotSuccess,
    [Types.CREATE_FORGOT_ERROR]: processCreateForgotError,
    [Types.CREATE_LOGOUT_REQUEST]: processCreateLogoutRequest,
    [Types.CREATE_LOGOUT_SUCCESS]: processCreateLogoutSuccess,
    [Types.CREATE_LOGOUT_ERROR]: processCreateLogoutError,

    [Types.RESET_PASSWORD_REQUEST]: processResetPasswordRequest,
    [Types.RESET_PASSWORD_SUCCESS]: processResetPasswordSuccess,
    [Types.RESET_PASSWORD_ERROR]: processResetPasswordError
})

/* ------------- Selectors ------------- */

export const isLoggedIn = (loginState: Object) => loginState.loginToken !== null
